import createModule from "../createModule"
import view from "./view"

export default createModule({
  view,
})
